import { Select } from "@shopify/polaris";
import { useCallback } from "react";
import {
  REAL_TIME,
  TIME_12_HR,
  TIME_1_DAY,
  TIME_1_HR,
  TIME_30_MIN,
  TIME_6_HR,
  TIME_7_DAY
} from "../../../../../../../../../../constants/timeInMs.js";

const options = [
  { label: "Real-time", value: REAL_TIME },
  { label: "30 minutes", value: TIME_30_MIN },
  { label: "1 hour", value: TIME_1_HR },
  { label: "6 hours", value: TIME_6_HR },
  { label: "12 hours", value: TIME_12_HR },
  { label: "1 day", value: TIME_1_DAY },
  { label: "7 days", value: TIME_7_DAY }
];

const RunActionEveryField = ({ input }) => {
  const handleChangeSelect = useCallback((value) => {
    input.onChange({ ...input.value, runActionEvery: value });
  }, [input]);

  return (
    <Select
      label="Every period of time"
      options={options}
      onChange={handleChangeSelect}
      value={input.value.runActionEvery}
    />
  );
};

export default RunActionEveryField;